const serviceActionFn = (url) => {
  return `Action?action=/${url}`;
}
const cacheActionFn = (actionId) => {
  return `Cache?actionId=${actionId}`;
}
/* const catchStatus9 = {
  key: "status", value: "9"

  //捕获到 status = 9 时的回调
  , fn: response => {
    console.log("catch status 9", response);
    //需先 set(vm)
    vm.$router.push("/login");
  }

  //是否进入 error
  , return: false
} */

//to get and post
const resources = {

  //格式：
  //* url 必须
  getOrderMapInfo: { url: 'receive-service/orderProcess/v2/getOrderMapInfo' }     // 订单地图相关信息

}
for (let k in resources) {
  resources[k].url = serviceActionFn(resources[k].url);
}
export { resources }

const caches = {
  set: { action: 1 }
  , get: { action: 2 }
  , check: { action: 3 }
}
for (let k in caches) {
  caches[k].url = cacheActionFn(caches[k].action);
}
export { caches }




// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/orderLocation/serviceConfig.js